import React from 'react'
import CommentList from './CommentList'
import CommentWrite from './CommentWrite'

const CommentArea = () => {

    return (
        <div>
            <CommentList />
            <CommentWrite />
        </div>
    )
}

export default CommentArea